var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import cxs from 'cxs/component';
var Icomoon = /** @class */ (function (_super) {
    __extends(Icomoon, _super);
    function Icomoon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icomoon.prototype.render = function () {
        var _a = this.props, name = _a.name, props = __rest(_a, ["name"]);
        return React.createElement(StyledIcon, __assign({}, props), name);
    };
    return Icomoon;
}(Component));
export default Icomoon;
var StyledIcon = cxs('div')(function (_a) {
    var size = _a.size;
    return ({
        display: 'inline-block',
        fontFamily: 'logo',
        fontSize: size ? size + 'px' : Theme.fontSize.big,
        textTransform: 'initial',
        lineHeight: 1,
        padding: Theme.size.space[1],
    });
});
StyledIcon.propTypes = {
    size: PropTypes.number
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/Icomoon.tsx
// module id = 462
// module chunks = 0